import { render, staticRenderFns } from "./ButtonSize.vue?vue&type=template&id=124538d0&"
import script from "./ButtonSize.vue?vue&type=script&lang=js&"
export * from "./ButtonSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports